<template>
<v-expand-transition>
<div v-if="transactions.length > 1">
    <div @click="goToAnother(transaction['.key'])" v-for="transaction in transactions" :key="transaction['.key']" class="simultaneous-transaction" :class="{'active': transaction.active, 'hoverable': !transaction.active, 'clickable': !transaction.active}">
        {{transaction.description}} <span class="subtle">{{transaction.created | shortDate}}</span>
        <a :href="getLink(transaction['.key'])" @click.stop class="transparent" target="_blank">
        <v-btn v-if="!transaction.active" color="grey darken-1" icon text small style="float:right;margin-right:-7px;margin-top:-3px;">
            <v-icon small>mdi-open-in-new</v-icon>
        </v-btn>
        </a>
    </div>
</div>
</v-expand-transition>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import ElementHelpers from '../helpers/ElementHelpers'
import NiceData from '../data/NiceData'
import Utilities from '../helpers/Utilities'
import Flag from '../ui-elements/Flag'


export default {
    data() {
    return {
        transactions: [],
    }
    },

    components: {
        Flag
    },
    
    props: {
        transactionKey: String,
        delay: {
            default: 3000, 
            type: Number,
        }
    },  

    computed: {
 
    },

    methods: {
        getLink(transactionKey) {
            return window.location.href.replace(this.transactionKey, transactionKey)
        },
        goToAnother(transactionKey) {
            let link = this.getLink(transactionKey)
            window.location.href = link
        },
        loadTransactions() {
            let transactions = []
            let promises = []

            ElementHelpers.fetchContactsForRole(this.transactionKey, 'Client').then(clients => {
                clients.forEach(client => {
                    let clientKey = client.key
                    let ref = DataHelpers.getTenantRef().child('contactTransactions').child(clientKey)
                    let promise = NiceData.fetchItemsFromFirebase(ref)
                    
                    console.log(ref.toString())
                    NiceData.fetchItemsFromFirebase(ref).then(res => {
                        console.log(res)
                        
                    })
                    promises.push(promise)
                })
                Promise.all(promises).then(result => {
                    let uniqueTransactionsObj = {}
                    result.forEach(transactions => {
                        transactions.forEach(transaction => {
                            const transactionKey = transaction.meta.key
                            delete transaction.meta
                            if(transactionKey == this.transactionKey) {
                                transaction.active = true
                            }
                            
                            uniqueTransactionsObj[transactionKey] = transaction
                        })
                    })
                    this.transactions = Utilities.objectToObjectArray(uniqueTransactionsObj).sort( (a, b) => a.created > b.created)
                    
                })
            })
        },
    },

    created() {
        setTimeout( () => {
            this.loadTransactions()
        }, this.delay)

    }
}
</script>

<style scoped>
    .simultaneous-transaction {
        border-left: solid 5px #ddd;
        margin:5px; padding:5px 8px;
        border-radius: 0px 3px 3px 0px;
        color:#666
    }
    .active {border-left: solid 5px #1c75d2}
    .subtle {font-size: .8em; color: #aaa}
   
</style>




// WEBPACK FOOTER //
// SimultaneousTransactions.vue?42a14622